import { Checkbox, Input } from "antd";
import styled from "styled-components";
import Loader from "../../common/Loader";
import { API_PERMISSIONS } from "../../../utils/apis";
import { useEffect, useMemo, useRef, useState } from "react";
import useGet from "../../../hooks/common/useGet";

export const Permissions = ({
  role_permissions = [],
  updateFormValue,
}: any) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { loadData, data: permissions, loading } = useGet();
  const [permissionsList, setPermissionsList] = useState<any[]>([]);
  const gottenPermissions = useRef(false);

  // Load initial permissions
  useEffect(() => {
    loadData({
      api: API_PERMISSIONS,
    });
    gottenPermissions.current = true;
  }, []);

  useEffect(() => {
    if (permissions?.results) {
      setPermissionsList((prev) => {
        const combined = [...prev, ...permissions.results];
        return [...new Map(combined.map((p) => [p.codename, p])).values()];
      });

      if (gottenPermissions.current && permissions?.next) {
        let nextUrl = permissions.next
          .replace(/^https?:\/\/[^/]+/, "")
          .replace(/^\/api/, "")
          .replace(/^\/+/, "")
          .replace(/\/{2,}/g, "/");
        loadData({ api: nextUrl });
      }
    }
  }, [permissions]);

  // Serach permissions
  const filteredPermissions = useMemo(() => {
    return permissionsList?.filter(
      (perm: any) =>
        perm?.codename?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        perm?.name?.toLowerCase().includes(searchQuery.toLowerCase()),
    );
  }, [searchQuery, permissionsList]);

  const onChange = (e: any) => {
    const checked = e.target.checked;
    // contains codename and name
    const permission = e.target.value;

    if (checked) {
      updateFormValue("permissions", [...role_permissions, permission]);
    } else {
      // filter out the unchecked permission
      const newSelected = role_permissions?.filter(
        (obj: any) => obj?.codename !== permission?.codename,
      );
      updateFormValue("permissions", newSelected);
    }
  };

  if (loading && !permissionsList) return <Loader />;

  return (
    <PermissionsContainer>
      <Input
        placeholder="Search permissions..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        style={{ marginBottom: "20px", maxWidth: "50%" }}
        allowClear
      />
      <PermissionsWrapper>
        {filteredPermissions?.map((permission: any, i: number) => (
          <Checkbox
            key={i}
            onChange={onChange}
            value={permission}
            defaultChecked={role_permissions?.find(
              (obj: any) => obj.codename === permission?.codename,
            )}
            className="capitalize"
          >
            {permission?.name}
          </Checkbox>
        ))}
      </PermissionsWrapper>
    </PermissionsContainer>
  );
};

const PermissionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const PermissionsWrapper = styled.div`
  display: grid;
  gap: 30px;
  width: 100%;
  grid-template-columns: repeat(4, 1fr);

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;
